// extracted by mini-css-extract-plugin
export var container = "_43-0";
export var disabled = "_43-4";
export var fullWidth = "_43-3";
export var lined = "_43-1";
export var selected = "_43-5";
export var tab = "_43-2";